export enum LocalStorage {
  VIEW_MODE = 'view-mode',
  BRAND_KEY = 'brand-key',
  SHOW_SIDEBAR = 'show-sidebar',
  SHOW_LEADS_STATS = 'show-leads-stats',
  SELECTED_LANGUAGE = 'selected-language',
  AUTH0_CYPRESS = 'auth0-cypress',
  PAGE_HAS_BEEN_FORCE_REFRESHED = 'page-has-been-force-refreshed',
  MGA_ORDER = 'mga-order',
  DATA_GRID_STATE = 'data-grid-state-',
  ASSORTMENT_VIEW = 'assortment-view',
  LAST_VISITED_TAB = 'last-visited-tab',
  INSIGHTS_SELECTED_TAB = 'insights-selected-tab',
  DATA_GRID_COLUMN_VISIBILITY = 'data-grid-column-visibility-',
}
